<template>
  <div class="container_box">
    <div class="box">
      <div class="foot-left">
        <!-- <img class="img-log" src="../../assets/logo.png" alt=""> -->
          <svg-icon class="logo" icon-class="logo" />
        <div class="font-phone">
          <p>{{ $t('common.phone') }}：<span class="small-font">400 821 3731</span></p>
          <p>EMAIL：<span class="small-font">sales@worthtec.com</span></p>
        </div>
        <div class="font-phone">
          <p>{{ $t('common.address') }}</p>
          <p><span class="small-font">{{ $t('common.addressStr') }}</span></p>
        </div>
      </div>
      <div class="foot-right">
        <div class="list-foot">
          <router-link to="/services" class="fontp">{{ $t('common.platformService') }}</router-link>
          <ul class="font-ul">
            <li><router-link :to="{path: '/services', query: {anchorPoint: 'promise' }}" class="font-li">供应保证</router-link></li>
            <li><router-link :to="{path: '/services', query: {anchorPoint: 'cost' }}" class="font-li">成本降低</router-link></li>
            <!-- <li><router-link to="/services" class="font-li">{{ $t('common.qualityAssurance') }}</router-link></li> -->
          </ul>
        </div>
        <div class="list-foot">
          <router-link to="/platform" class="fontp">产品中心</router-link>
          <ul class="font-ul">
            <li><router-link :to="{path: '/platform', query: {anchorPoint: 'backstage' }}" class="font-li">沃时数据中台</router-link></li>
            <li><router-link :to="{path: '/platform', query: {anchorPoint: 'client' }}" class="font-li">沃时包装助手</router-link></li>
            <li><router-link :to="{path: '/platform', query: {anchorPoint: 'supplier' }}" class="font-li">沃时供应链助手</router-link></li>
            <li><router-link :to="{path: '/platform', query: {anchorPoint: 'app' }}" class="font-li">沃时货运助手</router-link></li>
            <li><router-link :to="{path: '/platform', query: {anchorPoint: 'pad' }}" class="font-li">沃时云智造</router-link></li>
          </ul>
        </div>
        <div class="list-foot">
          <router-link to="/company" class="fontp">{{ $t('common.aboutUs') }}</router-link>
          <ul class="font-ul">
            <li><router-link :to="{path: '/company', query: {anchorPoint: 'introduce' }}" class="font-li">{{ $t('common.companyProfile') }}</router-link></li>
            <li><router-link :to="{path: '/company', query: {anchorPoint: 'honor' }}" class="font-li">{{ $t('common.awards') }}</router-link></li>
            <li><router-link :to="{path: '/company', query: {anchorPoint: 'experience' }}" class="font-li">{{ $t('common.milestones') }}</router-link></li>
          </ul>
        </div>
      </div>
      <div class="twoimg">
        <img src="../../assets/mpcode.png" alt="">
      </div>
    </div>
    <div class="remark">
      Copyright © 2015 - 2020 沃时派客（上海）包装科技有限公司保留所有权利。
      <a target="_blank" href="https://beian.miit.gov.cn/">
        <span>沪ICP备20024809号-3 </span>
      </a>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502000869">
          <img style="width: 20px; height: 20px;margin:0 3px" alt="" src="../../assets/publicSecurity2.png">
          <span>沪公安网备 31010502000869号</span>
        </a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
.container_box {
  width: 100%;
  height: 360px;
  background: #242B3D;
  .box {
    height: 330px;
    display: flex;
    justify-content: center;
    .foot-left {
      margin-right: 126px;
      .logo{
        margin-top: 60px;
        width: 180px;
        height: 40px;
      }
    }
    .img-log {
      margin-top: 45px;
      width: 200px;
    }
    .font-phone {
      font-size: 14px;
      margin-top: 30px;
      line-height: 20px;
      font-weight: 600;
      color: #ffffff;
      p {
        margin: 0px;
        width: 250px;
      }
      .small-font {
        font-weight: 500;
      }
    }
    .foot-right {
      display: flex;
      justify-content: space-between;
      margin-top: 64px;
      color: #ffffff;
      .list-foot {
        width: 200px;
      }
      .fontp {
        display: inline-block;
        font-size: 18px;
        line-height: 25px;
        margin: 0px 0px 25px;
        font-weight: 600;
        color: #ffffff;
      }
      .font-ul .font-li{
        display: inline-block;
        list-style: none;
        line-height: 38px;
        padding: 0px;
        color: #ffffff;
      }
      .font-li:hover{
        text-decoration: underline;
      }
    }
    .twoimg {
      margin-top: 45px;
    }
  }
  .remark{
    display: flex;
    align-items: center;
    justify-content: center;
    width:100%;
    height:60px;
    background: #ffffff;
    font-size: 14px;
    margin:0px;
    line-height: 60px;
    text-align: center;
    a{
      display: flex;
      align-items: center;
    }
  }
}
</style>
